import { useState, useEffect } from 'react';
import Script from 'next/script';
import { useCustomerPrivacy } from './hooks';
import { changeFueledConsent } from './fueled.utils';

const PUBLIC_TRUE_VAULT_SDK_URL = `https://polaris.truevaultcdn.com/static/pc/UZTLJPM2J/polaris.js`;

export const useGetTrueVaultConsent = () => {
  const [consent, setConsent] = useState();

  const { customerPrivacy } = useCustomerPrivacy({
    storefrontAccessToken: process.env.SHOPIFY_STOREFRONT_API_TOKEN,
    checkoutDomain: process.env.SHOPIFY_CART_DOMAIN || 'shop.brumate.com',
    onVisitorConsentCollected: (newConsent) => {
      console.log('Visitor consent collected:', newConsent);

      setConsent({
        analytics: newConsent.analyticsAllowed,
        marketing: newConsent.marketingAllowed,
        preferences: newConsent.preferencesAllowed,
        sale_of_data: newConsent.saleOfDataAllowed,
      });
    },
  });

  useEffect(() => {
    if (!customerPrivacy?.analyticsProcessingAllowed) return;

    if (!consent) {
      customerPrivacy.setTrackingConsent({
        analytics: customerPrivacy?.analyticsProcessingAllowed?.(),
        marketing: customerPrivacy?.marketingAllowed?.(),
        preferences: customerPrivacy?.preferencesProcessingAllowed?.(),
        sale_of_data: customerPrivacy?.saleOfDataAllowed?.(),
      });
    }
  }, [customerPrivacy?.analyticsProcessingAllowed]);

  useEffect(() => {
    if (consent) {
      changeFueledConsent(consent);
    }

    const handleFueledReady = () => {
      if (!consent) return;

      changeFueledConsent(consent);
    };

    window.addEventListener('fueled-ready', handleFueledReady);

    return () => {
      window.removeEventListener('fueled-ready', handleFueledReady);
    };
  }, [consent]);

  return consent;
};

export function FueledTrueVault() {
  const trueVaultSdkUrl =
    process.env.PUBLIC_TRUE_VAULT_SDK_URL || PUBLIC_TRUE_VAULT_SDK_URL;

  return (
    <Script
      strategy="beforeInteractive"
      type="text/javascript"
      src={trueVaultSdkUrl}
    />
  );
}
